
import Swiper, { Navigation } from 'swiper';

const TimeLine = () => {
    if (document.getElementById('timestoria') ) {
        const timelines = document.querySelectorAll('.t-click');
        const items = document.querySelectorAll('.timeline-item ');
        const timelineup = document.getElementById('timeline-up');
        const timelinedown = document.getElementById('timeline-down');

        let timelineSwiper = new Swiper('.timelineswiper', {
            //pagination: '.swiper-pagination',
            modules: [ Navigation ],
            navigation: {
                nextEl: '.timeline-down',
                prevEl: '.timeline-up',
            },
            slidesPerView: 3,
            direction: "horizontal",
            
            // Responsive breakpoints
            breakpoints: {
                992: {
                    slidesPerView: 5,
                    direction: "vertical"
                }
            },
        });

        timelines.forEach(el => el.addEventListener('click', event => {

            event.preventDefault();

            let currentid = event.target.getAttribute("data-id");

            timelines.forEach(node => {
                node.parentNode.classList.remove('active');
            });

            //event.target.scrollIntoView();

            items.forEach(node => {
                node.classList.remove('active');
            });
            event.target.parentNode.classList.add('active');
            let current = document.getElementById(currentid);
            current.classList.add('active');

        }));

        // timelineup.addEventListener('click', event => {
        //     event.preventDefault();

        //     let currentli = document.querySelector('.timeline-storia li.active');
        //     let prevli = currentli.previousElementSibling;
        //     if ( prevli ) {

        //         timelines.forEach(node => {
        //             node.parentNode.classList.remove('active');
        //         });

        //         items.forEach(node => {
        //             node.classList.remove('active');
        //         });
        //         prevli.classList.add('active');
        //         let current = document.getElementById( prevli.querySelector('a').getAttribute("data-id"));
        //         current.classList.add('active');
        //     }


        // });

        // timelinedown.addEventListener('click', event => {
        //     event.preventDefault();
        //     let currentli = document.querySelector('.timeline-storia li.active');
        //     let nextli = currentli.nextElementSibling;
        //     if ( nextli ) {
        //         timelines.forEach(node => {
        //             node.parentNode.classList.remove('active');
        //         });

        //         items.forEach(node => {
        //             node.classList.remove('active');
        //         });
        //         nextli.classList.add('active');
        //         let current = document.getElementById( nextli.querySelector('a').getAttribute("data-id"));
        //         current.classList.add('active');
        //     }
        // });
    }
};

export default TimeLine;